import { useRef } from 'react';
import { getDate } from '../../../../../utils/dateUtils';

const PaymentReceivedTable = ({
	isDisabled,
	handleClearAppliedAmount,
	productTableData,
	errors = [],
	tableColumns,
	handlePaymentChange,
	handleFullPaymentToggle,
	calculateTotalPayment,
}) => {
	const inputRefs = useRef([]);
	function changeInputByEnter(index) {
		if (productTableData.length > index) {
			if (inputRefs.current[index + 1]) {
				inputRefs.current[index + 1].focus();
			}
		}
	}

	const handleKeyDown = (index, event) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			changeInputByEnter(index);
		}
	};

	return (
		<div>
			<div style={{ fontSize: '14px', fontWeight: 'bold', color: '#000' }}>
				{'Unpaid Invoices'}

				<div
					style={{
						float: 'right',
						display: 'block',
						borderBottom: '1px solid #3B58FF',
						color: '#3B58FF',
						fontWeight: 'bold',
						cursor: isDisabled ? 'not-allowed' : 'pointer',
					}}
					onClick={handleClearAppliedAmount}
				>
					Clear Applied Amount
				</div>
			</div>
			<table
				style={{ borderCollapse: 'collapse', marginTop: '10px' }}
				className="max-w-1297"
			>
				<thead>
					<tr style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}>
						{tableColumns.map((col, index) => (
							<th
								key={index}
								style={{
									padding: '8px',
									border: '1px solid #dee2e6',
									textAlign: col === 'Date' || col === 'Bill#' || col === 'PO#' ? 'left' : 'right',
								}}
							>
								{col}
							</th>
						))}
					</tr>
				</thead>
				<tbody style={{ color: '#555B67', fontWeight: 'bold' }}>
					{productTableData?.map((pr, index) => (
						<tr
							key={index}
							style={{
								backgroundColor: index === 1 ? '#f0f8ff' : 'transparent',
								height: '80px',
							}}
						>
							{
								<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'left' }}>
									{pr?.date !== null ? getDate(pr.date) : ''}
									<br />
									<span style={{ fontSize: '12px' }}>
										Due Date:{' '}
										<span style={{ color: '#000000', fontWeight: 'bold' }}>
											{pr?.due_date !== null ? getDate(pr?.due_date) : ''}
										</span>
									</span>
								</td>
							}

							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								{pr?.invoice_number}
							</td>

							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								{pr?.amount}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								{pr?.due_amount}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								<div
									style={{
										marginTop: '4px',
										display: 'flex',
										justifyContent: 'flex-end',
										flexDirection: 'column',
										alignItems: 'end',
										width: '100%',
									}}
								>
									<input
										className="table_input"
										type={'text'}
										name={'Payment Amount'}
										value={pr?.payment_amount}
										style={{
											border:
												errors.filter((data) => data.index === index && data.error !== '').length >
													0 &&
												errors
													.filter((data) => data.index === index && data.error !== '')
													.map((item) => item.error)
													? '1px solid red'
													: '1px solid rgba(85, 91, 103, 0.15)',
											borderRadius: '8px',
											height: '38px',
											width: '165px',
											textAlign: 'right',
										}}
										onChange={(e) => {
											var valueData = e.target.value;
											var value = valueData?.replace(/[^0-9.]/g, '');
											handlePaymentChange(index, value);
										}}
										onKeyDown={(e) => {
											handleKeyDown(index, e);
										}}
										ref={(el) => (inputRefs.current[index] = el)}
									/>

									<span style={{ color: 'red', fontSize: '14px' }}>
										{errors.filter((data) => data.index === index && data.error !== '').length >
											0 &&
											errors
												.filter((data) => data.index === index && data.error !== '')
												.map((item) => item.error)}
									</span>
								</div>

								<div
									style={{
										cursor: 'pointer',
										marginTop: '4px',
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										width: '100%',
									}}
								>
									<div
										style={{
											borderBottom: '1px solid #3B58FF',
											fontSize: '12px',
											color: '#3B58FF',
											fontWeight: 'bold',
											whiteSpace: 'nowrap',
											cursor: 'pointer',
										}}
										onClick={() => {
											if (Number(pr?.payment_amount) > 0) {
												handleFullPaymentToggle(index, 'clear');
											} else {
												handleFullPaymentToggle(index, 'pay');
											}
										}}
									>
										{Number(pr?.payment_amount) > 0 ? 'Clear Amount' : 'Pay in Full'}
									</div>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{/* Total Section */}
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
					padding: '8px 10px',
					backgroundColor: '#f8f9fa',
					border: '1px solid #dee2e6',
				}}
			>
				<div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
					<span style={{ fontWeight: 'bold', color: '#555B67' }}>Total :</span>
					<span style={{ fontWeight: 'bold' }}>
						₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}
					</span>
				</div>
			</div>
			{/* Summary Section */}
		</div>
	);
};
export default PaymentReceivedTable;
